import { useCallback, useMemo, useState } from "react"
import { TextMatch } from "shared/text"
import { ManufacturerResult, useListManufacturer } from "interface/manufacturer"

export const useManufacturerManagementContainer = () => {
	const [searchWord, setSearchWord] = useState("")
	const [edittedManufacturerList, setEdittedManufacturerList] = useState<ManufacturerResult[] | null>(null)

	const manufacturerListState = useListManufacturer()
	const manufacturerList = useMemo(() => {
		const list = edittedManufacturerList ?? manufacturerListState.data?.list
		if (!list) return null
		if (searchWord === '') return list
		const match = new TextMatch(searchWord)
		return list.filter((manufacturer) => match.match(manufacturer.manufacturerName))
	}, [manufacturerListState, edittedManufacturerList, searchWord])

	const onAddManufacturer = useCallback(
		(manufacturer: ManufacturerResult) => {
			const list = edittedManufacturerList ?? manufacturerListState.data?.list
			if (!list) return
			setEdittedManufacturerList([...list, manufacturer])
		},
		[edittedManufacturerList, manufacturerListState, setEdittedManufacturerList]
	)
	const onEditManufacturer = useCallback(
		(manufacturer: ManufacturerResult) => {
			const list = edittedManufacturerList ?? manufacturerListState.data?.list
			if (!list) return
			setEdittedManufacturerList(
				list.map((exist) => exist.manufacturerId === manufacturer.manufacturerId ? manufacturer : exist)
			)
		},
		[edittedManufacturerList, manufacturerListState, setEdittedManufacturerList]
	)
	const onDeleteManufacturer = useCallback(
		(manufacturerId: number) => {
			const list = edittedManufacturerList ?? manufacturerListState.data?.list
			if (!list) return
			setEdittedManufacturerList(
				list.filter((exist) => exist.manufacturerId === manufacturerId ? false : true)
			)
		},
		[edittedManufacturerList, manufacturerListState, setEdittedManufacturerList]
	)

	return useMemo(() => ({
    loading: manufacturerListState.loading,
    error: manufacturerListState.error,
    manufacturerList,
    searchWord,
    setSearchWord,
 		onAddManufacturer,
 		onEditManufacturer,
		onDeleteManufacturer,
	}), [
		manufacturerListState,
    manufacturerList,
    searchWord,
    setSearchWord,
 		onAddManufacturer,
		onEditManufacturer,
		onDeleteManufacturer,
	])
}